import styled from '@emotion/styled/macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const InputContainer = styled.div<{
  customWidth?: string
  customMargin?: string
}>`
  display: flex;
  align-items: center;
  width: ${({ customWidth }) => customWidth || 'initial'};
  margin-bottom: 1.5rem;
  ${props =>
    props.customMargin &&
    `
    margin: margin-bottom: 1.5rem;
    margin: ${props.customMargin};
  `}
`

export const InputTextField = styled.div`
  position: relative;
`

export const InputLabel = styled.label<{
  fieldColor: string
  isInputFocus: boolean
  isLeadingIcon: boolean
  isTrailingIcon: boolean
  isForceLabel?: boolean
}>`
  position: absolute;
  z-index: 1;
  font-size: 1rem;
  left: 0;
  background-color: white;
  color: ${({ isInputFocus, fieldColor }) =>
    isInputFocus ? fieldColor : 'grey'};
  padding: 0 0.3rem;
  transition: 0.1s ease-out;
  transform-origin: left top;
  pointer-events: none;
  top: ${({ isInputFocus, isForceLabel }) =>
    isInputFocus || isForceLabel ? 0 : '50%'};
  transform: ${({ isInputFocus, isForceLabel }) =>
    isInputFocus || isForceLabel
      ? 'translateY(-50%) scale(0.9)'
      : `translateY(-50%)`};
  margin: ${({ isLeadingIcon, isInputFocus, isForceLabel }) =>
    isLeadingIcon && !isInputFocus && !isForceLabel
      ? ' 0 0 0 32px'
      : '0 0.5rem'};
`

export const InputLeadingIcon = styled(FontAwesomeIcon)`
  color: #989898;
  width: 25px;
  position: absolute;
  background-color: white;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 0.5rem;
  left: 0;
`

export const InputTrailingIcon = styled(FontAwesomeIcon)`
  color: #989898;
  width: 25px;
  position: absolute;
  background-color: white;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 0.5rem;
  right: 0;
  z-index: 2;
`
